import { SpyneTrait, ViewStream } from "spyne";
import { UtilTraits } from "traits/util-traits";

import WiringTemplate from "../components/code-playground/example-templates/wiring-trait-template.tmpl.html";
export class CodePlaygroundExamplesWiringTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeWiring$";

    super(context, traitPrefix);
  }

  static codeWiring$HelloWorld() {
    return "Hello World";
  }

  static codeWiring$Listening() {
    class WiringTraits extends SpyneTrait {
      constructor(context) {
        let traitPrefix = "wiring$";
        super(context, traitPrefix);
      }

      static wiring$HelloWorld(props = this.props) {
        this.props.el$(".output").el.textContent = `Hello World!`;
      }

      static wiring$AddInput(e, props = this.props) {
        const { value } = e.srcElement.el;
        this.props.el$(".output").el.textContent = `Hello ${value}!`;
      }
    }

    class MyInputsExample extends ViewStream {
      constructor(props = {}) {
        props.traits = WiringTraits;
        props.template = WiringTemplate;

        super(props);
      }

      addActionListeners() {
        return [
          ["CHANNEL_UI_CLICK_EVENT", "wiring$HelloWorld"],
          ["CHANNEL_UI_KEYUP_EVENT", "wiring$AddInput"],
        ];
      }

      broadcastEvents() {
        return [
          ["button", "click"],
          ["input", "keyup"],
        ];
      }

      onRendered() {
        this.addChannel("CHANNEL_UI");
      }
    }

    class MyOutputExample extends ViewStream {
      constructor(props = {}) {
        props.traits = [WiringTraits];
        props.template = "<p>output</p>";
        super(props);
      }

      addActionListeners() {
        return [
          ["CHANNEL_UI_CLICK_EVENT", "onClickEvent"],
          ["CHANNEL_UI_KEYUP_EVENT", "onInputEvent"],
        ];
      }
      onClickEvent(e) {
        this.props.el.innerHTML = `Hello ${this.props.nameIterator()}!`;
      }
      onInputEvent(e) {
        const { value } = e.srcElement.el;
        this.props.el.innerHTML = `Hello ${value}!`;
      }
      onRendered() {
        this.props.nameIterator = this.createArrayIterator();
        this.addChannel("CHANNEL_UI");
      }
    }

    const template = document.createElement("template");
    template.innerHTML = `          <button id="wiring-example-btn">My Button</button>
          <label for="wiring-example-input">Input</label>
          <input id="wiring-example-input" type="text" />
          <p>output</p>`;

    this.appendView(new MyInputsExample());

    // return `      ${MyInputsExample}`

    //console.log("WIRING TEMPL ",UtilTraits.util$EscapeHTMLChars(WiringTemplate));

    return [
      {
        tabName: "Viewstream",
        scriptString: `      ${MyInputsExample}\n\n    new MyInputsExample().appendToDom(document.body)`,
      },
      { tabName: "WiringTraits", scriptString: `      ${WiringTraits}` },
      {
        tabName: "WiringTemplate",
        scriptString: `${UtilTraits.util$EscapeHTMLChars(WiringTemplate)}`,
      },
    ];
  }
}
